import { createGlobalStyle } from "styled-components";

const Colors = createGlobalStyle`
  :root {
    --deep-sky-blue: #0079ff;
    --crystal-blue: #60ABFF;
    --greyish-blue: #697c9a;
    --kashmir-blue: #4b6a9b;
    --gunmetal: #2b3442;
    --zircon: #f6f8ff;
    --romance: #fefefe;
    --white: #fff;
    --mirage: #141D2F;
    --blue-zodiac: #1e2a47;
  }
`;

export default Colors;
